export class UserProfile {
    uId: string;            // same value as firebase.auth().currentUser.uid
    first: string;
    last: string;
    middle?: string;
    registered?: any;
    email?: string;
    gender?: string;         // male, female, na
    userAckWelcome?: number; // unix date
    tzone?: number;
    stripeId?: string;
    revai_access_token?: string;
    ingestion_url?: string;
    youtube_link?: string;
    standard_subscribe_id?: string;
    additional_subscribe_id?: string;
}
